<div class="card-form">
  @if (showCreditCard) {
    <div class="card-list">
      <pxw-card
        [cardModel]="cardModel"
        [cardNumberFormat]="cardNumberFormat"
        [displayedCardNumber]="displayedCardNumber"
        [focusedElement]="focusedElement"
      ></pxw-card>
    </div>
  }
  <div class="card-form__inner" [ngStyle]="{ 'padding-top': !showCreditCard ? '0' : '' }">
    <div class="card-input">
      <label for="cardNumber" class="ui-label ui-label--md">{{ formLabels.typeCard }}</label>
      <dx-radio-group
        [items]="cardTypes"
        valueExpr="value"
        displayExpr="label"
        [(value)]="cardModel.creditCard"
        layout="horizontal"
        >
        <dx-validator>
          <dxi-validation-rule
            type="required"
            message="El tipo de tarjeta es requerido"
          ></dxi-validation-rule>
        </dx-validator>
      </dx-radio-group>
    </div>
    <div class="card-input">
      <label for="cardNumber" class="ui-label ui-label--md">{{ formLabels.cardNumber }}</label>
      <div class="ui-input__container">
        <dx-text-box
          [value]="displayedCardNumber"
          (onInput)="onCardNumberChange($event)"
          (onFocusIn)="onCardNumberFocus()"
          (onBlur)="onCardNumberBlur()"
          [inputAttr]="{
            autocomplete: 'off',
            maxlength: cardNumberMaxLength,
            id: cardNumberId,
            type: 'tel'
          }"
          stylingMode="underlined"
          >
          <dx-validator>
            <dxi-validation-rule
              type="required"
              message="El número de tarjeta es requerido"
            ></dxi-validation-rule>
            <dxi-validation-rule
              type="stringLength"
              [min]="cardNumberMaxLength"
              message="El número está incompleto"
            ></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>
    </div>
    <div class="holder-row">
      <div class="card-input">
        <label for="cardName" class="ui-label ui-label--md">{{ formLabels.cardHolderName }}</label>
        <div class="ui-input__container">
          <dx-text-box
            [(value)]="cardModel.cardName"
            (onFocusIn)="onCardNameFocus()"
            (onBlur)="onBlur()"
            (onKeyUp)="onCardNameKeyPress($event)"
            valueChangeEvent="keyup"
            [inputAttr]="{
              autocomplete: 'off',
              id: cardNameId
            }"
            stylingMode="underlined"
            >
            <dx-validator>
              <dxi-validation-rule
                type="required"
                message="El nombre del titular es requerido"
              ></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>
      </div>
      @if (!showDocumentSelector) {
        <div class="card-input">
          <label [attr.for]="cardDniId" class="ui-label ui-label--md">{{ formLabels.cardHolderDNI }}</label>
          <div class="ui-input__container">
            <dx-text-box
              [(value)]="cardModel.dni"
              [mask]="getDocumentMask()"
              [inputAttr]="{
                autocomplete: 'off',
                id: cardDniId
              }"
              stylingMode="underlined"
              >
              <dx-validator>
                <dxi-validation-rule
                  type="required"
                  [message]="getDocumentValidationMessage()"
                ></dxi-validation-rule>
                <dxi-validation-rule
                  type="custom"
                  [validationCallback]="validateDocument"
                  [message]="getDocumentValidationErrorMessage()"
                ></dxi-validation-rule>
              </dx-validator>
            </dx-text-box>
          </div>
        </div>
      }
    </div>
    @if (showDocumentSelector) {
      <div class="card-input">
        <label [attr.for]="cardDniId" class="ui-label ui-label--md">{{ formLabels.cardHolderDNI }}</label>
        <div class="ui-input__container document-selector-row">
          <dx-select-box
            [(value)]="selectedDocumentType"
            [dataSource]="documentTypes"
            valueExpr="value"
            displayExpr="label"
            (onValueChanged)="onDocumentTypeChange()"
            stylingMode="underlined"
            [width]="100"
            [inputAttr]="{
              id: cardDocumentTypeId,
              'aria-label': formLabels.documentType
            }"
            >
          </dx-select-box>
          <dx-text-box
            [(value)]="cardModel.dni"
            [mask]="getDocumentMask()"
            [inputAttr]="{
              autocomplete: 'off',
              id: cardDniId
            }"
            stylingMode="underlined"
            class="document-input-flex"
            >
            <dx-validator>
              <dxi-validation-rule
                type="required"
                [message]="getDocumentValidationMessage()"
              ></dxi-validation-rule>
              <dxi-validation-rule
                type="custom"
                [validationCallback]="validateDocument"
                [message]="getDocumentValidationErrorMessage()"
              ></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>
      </div>
    }
    <div class="card-form__row">
      <div class="card-form__col">
        <label for="cardMonth" class="ui-label ui-label--md">{{ formLabels.expirationDate }}</label>
        <div class="card-form__group card-form__group--expiration">
          <div class="ui-input__container">
            <dx-select-box
              [(value)]="cardModel.expirationMonth"
              [inputAttr]="{ id: monthSelect }"
              [dataSource]="expirationMonths"
              (onBlur)="onBlur()"
              (onFocusIn)="onDateFocus()"
              [placeholder]="formLabels.expirationMonth"
              stylingMode="underlined"
              >
              <dx-validator>
                <dxi-validation-rule
                  type="required"
                  message="La mes de expiración es requerido"
                ></dxi-validation-rule>
              </dx-validator>
            </dx-select-box>
          </div>
          <div class="ui-input__container">
            <dx-select-box
              [(value)]="cardModel.expirationYear"
              [inputAttr]="{ id: yearSelectId }"
              [dataSource]="expirationYears"
              (onChange)="onYearChange()"
              (onBlur)="onBlur()"
              (onFocusIn)="onDateFocus()"
              [placeholder]="formLabels.expirationYear"
              stylingMode="underlined"
              >
              <dx-validator>
                <dxi-validation-rule
                  type="required"
                  message="La año de expiración es requerido"
                ></dxi-validation-rule>
              </dx-validator>
            </dx-select-box>
          </div>
        </div>
      </div>
      @if (showCvvInput) {
        <div class="card-form__col -cvv">
          <div class="card-input">
            <label for="cardCvv" class="ui-label ui-label--md">{{ formLabels.cvv }}</label>
            <div class="ui-input__container">
              <dx-text-box
                [value]="cardModel.cvv"
                (onValueChanged)="onCvvChange($event)"
                (onFocusIn)="onCvvFocus()"
                (onBlur)="onCvvBlur()"
                [maxLength]="4"
                [inputAttr]="{
                  autocomplete: 'off',
                  id: 'cardCvvId',
                  type: 'password'
                }"
                stylingMode="underlined"
                >
                <dx-validator>
                  <dxi-validation-rule
                    type="required"
                    message="El CVV es requerido"
                  ></dxi-validation-rule>
                  <dxi-validation-rule
                    type="stringLength"
                    [min]="3"
                    [max]="4"
                    message="El CVV debe tener entre 3 y 4 dígitos"
                  ></dxi-validation-rule>
                </dx-validator>
              </dx-text-box>
            </div>
          </div>
        </div>
      }
    </div>
    @if (showSubmitButton) {
      <button class="card-form__button">
        {{ formLabels.submitButton }}
      </button>
    }
  </div>
</div>
